"use strict";

// The .asb-breadcrumb-wrapper plugin appends the breadcrumb to the END of #content.
// Pages with the nav-tabs block already reposition it via organizePageWithNav();
// for all other pages, lift it to the top of #content so it sits above the content.
function positionBreadcrumb() {
  const main = document.getElementById("content");
  if (!main) return;
  // Nav-tab pages handle the breadcrumb themselves — don't fight that logic.
  if (document.querySelector('[data-testid="section-navigation-tabs"]')) return;

  const breadcrumb = main.querySelector(".asb-breadcrumb-wrapper");
  if (!breadcrumb) return;
  if (main.firstElementChild === breadcrumb) return; // already at top

  main.insertBefore(breadcrumb, main.firstElementChild);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", positionBreadcrumb);
} else {
  positionBreadcrumb();
}
document.addEventListener("ajax:loaded", positionBreadcrumb);
